import { DateTime, Interval } from 'luxon';
import * as yup from 'yup';
import i18n from 'app-i18n';
import { capitalizeDayOfWeek } from '../scheduler-field.utils';
import { isTimeRangeValid } from '../../time-range-picker-field/time-range-picker-field.utils';
import { Schedule } from '../scheduler-field.context';

const hasOverlap = (schedules, inputInterval, daysOfWeek, timeFormat) =>
  schedules.some(schedule => {
    const scheduleInterval = Interval.fromDateTimes(
      DateTime.fromFormat(schedule.startTime, timeFormat),
      DateTime.fromFormat(schedule.endTime, timeFormat),
    );

    return (
      scheduleInterval.overlaps(inputInterval) &&
      (daysOfWeek.some(
        dayOfWeek => dayOfWeek.label === capitalizeDayOfWeek(schedule.day),
      ) ||
        daysOfWeek.some(day => day.id === 'ALL'))
    );
  });

export const schedulerToolbarFormSchema = (
  schedules: Schedule[],
  additionalDataSchema: yup.AnyObjectSchema,
  timeFormat?: string,
) =>
  yup
    .object({
      daysOfWeek: yup.array().required(),
      timeRange: yup
        .array()
        .required()
        .test(
          'validTimeRange',
          i18n.t(
            'forms.fields.schedulerToolBarForm.timeRange.errors.invalidTimeRange',
          ),
          isTimeRangeValid,
        )
        .test(
          'uniqueSchedule',
          i18n.t(
            'forms.fields.schedulerToolBarForm.timeRange.errors.overlapTimeRange',
          ),
          (value, context) => {
            const { parent } = context;
            const daysOfWeek = parent.daysOfWeek;

            if (
              Array.isArray(schedules) &&
              schedules.length > 0 &&
              Array.isArray(daysOfWeek) &&
              daysOfWeek.length !== 0 &&
              isTimeRangeValid(value)
            ) {
              const startTime = DateTime.fromFormat(
                value[0].toLocaleString(DateTime.TIME_SIMPLE),
                'h:mm a',
              );
              const endTime = DateTime.fromFormat(
                value[1].toLocaleString(DateTime.TIME_SIMPLE),
                'h:mm a',
              );

              const inputInterval = Interval.fromDateTimes(startTime, endTime);

              return !hasOverlap(
                schedules,
                inputInterval,
                daysOfWeek,
                timeFormat,
              );
            }

            return true;
          },
        ),
    })
    .concat(additionalDataSchema);
